import anisa1 from "./Media/Photos Gallery/anisa1.png";
import anisa2 from "./Media/Photos Gallery/anisa2.png";
import anisa3 from "./Media/Photos Gallery/anisa3.png";
import anisa4 from "./Media/Photos Gallery/anisa4.png";
import anisa5 from "./Media/anissa7.PNG";
import anisa6 from "./Media/anissa8.PNG";
import anisa from "./Media/anissa.PNG";
import anisa7 from "./Media/Photos Gallery/anissa6.png";
import Zymoral1 from "./Media/Photos Gallery/zymoral1.png";
import Zymoral2 from "./Media/Photos Gallery/zymoral2.png";
import Zymoral3 from "./Media/Photos Gallery/zymoral3.PNG";
import Zymoral4 from "./Media/Photos Gallery/zymoral4.PNG";
import Zymoral5 from "./Media/Photos Gallery/zymoral5.png";
import Gabby1 from "./Media/Photos Gallery/gabby1.png";
import Gabby2 from "./Media/Photos Gallery/gabby2.png";
import Dima1 from "./Media/Photos Gallery/dima1.png";
import Dima2 from "./Media/Photos Gallery/dima2.png";
import Dima3 from "./Media/Photos Gallery/dima3.png";

export const shopData = [
  {
    id: 1,
    name: "Anisa dress",

    description: "It comes in champagne brown, burgundy, red, black.",
    images: [anisa, anisa5, anisa6, anisa7],
    sizes: ["XS", "S", "M", "L", "XL"],
    prices: { GHS: 2000, USD: 170, GBP: 130, EUR: 150 },
  },
  {
    id: 2,
    name: "Zymoral dress",

    description: "",
    images: [Zymoral1, Zymoral2, Zymoral3, Zymoral4, Zymoral5],
    sizes: ["S", "M", "L", "XL", "XXL"],
    prices: { GHS: 1750, USD: 140, GBP: 120, EUR: 130 },
  },
  {
    id: 3,
    name: "Gabby dress",

    description: "",
    images: [Gabby1, Gabby2],
    sizes: ["S", "M", "L"],
    prices: { GHS: 1600, USD: 130, GBP: 110, EUR: 120 },
  },
  {
    id: 4,
    name: "Dima dress",

    description: "",
    images: [Dima1, Dima2, Dima3],
    sizes: ["S", "M", "L", "XL"],
    prices: { GHS: 1600, USD: 130, GBP: 110, EUR: 120 },
  },
  // {
  //   id: 5,
  //   name: "Essential Summer Shorts",

  //   description: "Lightweight summer shorts with a relaxed fit.",
  //   images: [
  //     "https://images.unsplash.com/photo-1591195853828-11db59a44f6b?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
  //   ],
  //   sizes: ["S", "M", "L", "XL"],
  //   prices: { GHS: 120, USD: 10, GBP: 8, EUR: 9 },
  // },
  // {
  //   id: 6,
  //   name: "Premium Cotton Beanie",

  //   description: "Soft premium cotton beanie for colder days.",
  //   images: [
  //     "https://images.unsplash.com/photo-1576871337622-98d48d1cf531?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
  //   ],
  //   sizes: ["One Size"],
  //   prices: { GHS: 80, USD: 6, GBP: 5, EUR: 6 },
  // },
];

// All measurements in inches.
export const bodyMeasurements = [
  {
    size: 4,
    label: "XSS",
    shoulderWidth: 13,
    neckWidth: 2.5,
    bust: 32,
    waist: 25,
    hips: 36,
    shoulderToBustPoint: 8.5,
    shoulderToUnderbust: 12.5,
    shoulderToWaist: 15,
    armholeLength: 6.5,
    armhole: 14,
  },
  {
    size: 6,
    label: "XS",
    shoulderWidth: 14,
    neckWidth: 2.75,
    bust: 34,
    waist: 27,
    hips: 38,
    shoulderToBustPoint: 9,
    shoulderToUnderbust: 12.5,
    shoulderToWaist: 15,
    armholeLength: 6.5,
    armhole: 15,
  },
  {
    size: 8,
    label: "S",
    shoulderWidth: 14.5,
    neckWidth: 3,
    bust: 36,
    waist: 28,
    hips: 40,
    shoulderToBustPoint: 9.5,
    shoulderToUnderbust: 13,
    shoulderToWaist: 15,
    armholeLength: null,
    armhole: 16,
  },
  {
    size: 10,
    label: "M",
    shoulderWidth: 16,
    neckWidth: 3,
    bust: 38,
    waist: 30,
    hips: 42,
    shoulderToBustPoint: 10,
    shoulderToUnderbust: 13.5,
    shoulderToWaist: 16,
    armholeLength: null,
    armhole: 17,
  },
  {
    size: 14,
    label: "L",
    shoulderWidth: 17,
    neckWidth: 3.25,
    bust: 42,
    waist: 34,
    hips: 46,
    shoulderToBustPoint: 11,
    shoulderToUnderbust: 15,
    shoulderToWaist: 17,
    armholeLength: null,
    armhole: 18,
  },
  {
    size: 16,
    label: "XL",
    shoulderWidth: 18,
    neckWidth: 3.5,
    bust: 44,
    waist: 36,
    hips: 48,
    shoulderToBustPoint: 11.5,
    shoulderToUnderbust: 16,
    shoulderToWaist: 18,
    armholeLength: null,
    armhole: 19,
  },
  {
    size: 20,
    label: "XXL",
    shoulderWidth: 18,
    neckWidth: 3.75,
    bust: 48,
    waist: 40,
    hips: 54,
    shoulderToBustPoint: 12.5,
    shoulderToUnderbust: 17,
    shoulderToWaist: 20,
    armholeLength: null,
    armhole: 22,
  },
];

// Maps a size chart "label" (XSS, XS, S, M, L, XL, XXL) to the numeric
// size, so ProductModal can look up the right row from item.sizes.
export const sizeLabelToNumber = bodyMeasurements.reduce((acc, row) => {
  acc[row.label] = row.size;
  return acc;
}, {});

// Hip-to-crotch length reference table.
// NOTE: source screenshot lists 42 then 41 — likely a typo, kept as-is.
export const hipToCrotch = [
  { hip: 32, crotch: 10 },
  { hip: 34, crotch: 10.5 },
  { hip: 36, crotch: 11 },
  { hip: 38, crotch: 11.5 },
  { hip: 40, crotch: 12.5 },
  { hip: 42, crotch: 13 },
  { hip: 41, crotch: 14 },
  { hip: 46, crotch: 14.5 },
  { hip: 48, crotch: 15 },
  { hip: 50, crotch: 15.5 },
];

// Measurement calculation formulas (as given in source material).
export const measurementFormulas = [
  { label: "Neck Width", formula: "Chest × 1/2" },
  { label: "Neck Depth", formula: "Chest ÷ 8 + 0.25" },
  { label: "Armhole", formula: "Chest ÷ 6" },
  { label: "Armhole Depth", formula: "Chest ÷ 24" },
];
